import PromoTag from './PromoTag.component';
export default PromoTag;